import React from "react";

function useSpec(user, activeOrg, forest) {
    const [spec, setSpec] = React.useState("");
    const [valid, setValid] = React.useState(false);
    const [ancestry, setAncestry] = React.useState({});
    React.useEffect(
        () => {
            const ancestry = {};

            function walk(it) {
                return it.kids
                    .flatMap(walk)
                    .map(c => ({
                        ...c,
                        path: c.path.concat(it.name),
                    }))
                    .concat({
                        path: [it.name],
                        perms: it.perms,
                    });
            }

            const toPathStr = c => c.path.join(">");
            const chains = forest
                .filter(f => f.kids && f.kids.length)
                .flatMap(f => {
                    const allLicenses = f.kids.flatMap(walk);
                    const aops = allLicenses
                        .filter(c => c.path[0] === activeOrg);
                    ancestry[f.name] = new Set(aops.flatMap(c => c.path));
                    const activeOrgPaths = aops
                        .map(toPathStr);
                    const toKeep = allLicenses.filter(c => {
                        // it has perms
                        if (c.perms && c.perms.length) return true;
                        // it's active org or a descendant
                        if (c.path.some(it => it === activeOrg)) return true;
                        // it's not the active org's ancestor
                        const pathStr = toPathStr(c);
                        return !activeOrgPaths.some(aop =>
                            aop.endsWith(pathStr));
                    });
                    return toKeep.map(c => {
                        const path = c.path
                            .map((it, i) => i === 0
                                ? it === activeOrg ? f.name : `${f.name}:${it}`
                                : it)
                            .join(">");
                        return c.perms
                            ? `${path}(${c.perms.join("|")})`
                            : path;
                    });
                })
                .sort((a, b) => {
                    // active org first
                    const ac = a.indexOf(":") >= 0;
                    const bc = b.indexOf(":") >= 0;
                    if (!ac && bc) return -1;
                    if (ac && !bc) return 1;
                    // lexicographical
                    if (a < b) return -1;
                    if (a > b) return 1;
                    return 0;
                });
            setAncestry(ancestry);
            setSpec(`${user}:${activeOrg}[${chains.join(",")}]`);
            setValid(chains.length > 0);
        },
        [user, activeOrg, forest],
    );
    return [spec, valid, ancestry];
}

export default useSpec;



// WEBPACK FOOTER //
// ./app/lib/reauth/useSpec.js